import { render, staticRenderFns } from "./DisplayPossibleWords.vue?vue&type=template&id=0e727cea&scoped=true&"
import script from "./DisplayPossibleWords.vue?vue&type=script&lang=js&"
export * from "./DisplayPossibleWords.vue?vue&type=script&lang=js&"
import style0 from "./DisplayPossibleWords.vue?vue&type=style&index=0&id=0e727cea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e727cea",
  null
  
)

export default component.exports